import get from 'lodash.get';

export const MEASURE = {
    TRC: 'TRC',
    OL: 'OL',
    VOCABO: 'VOCABO',
    OVERALL: 'OVERALL',
    SPELLING: 'SPELLING',
    LNF: 'LNF',
    PSF: 'PSF',
    NWF_CLS: 'NWF-CLS',
    NWF_WRC: 'NWF-WRC',
    WRF: 'WRF',
    ORF_ACC: 'ORF-ACC',
    ORF: 'ORF',
    MAZE: 'MAZE',
    LC: 'LC',
    IW: 'IW',
    AP: 'AP',
    RW: 'RW',

    FNL: 'FNL',
    QQ: 'QQ',
    FSS: 'FSS',
    FSLI: 'FSLI',
    FSL: 'FSL',
    LSS: 'LSS',
    FEP: 'FEP',
    FLO_PREC: 'FLO-ACC',
    FLO: 'FLO',
    CLPL: 'CLPL',
};

export const MEASURE_TITLE = {
    [MEASURE.TRC]: 'Reading Comprehension',
    [MEASURE.VOCABO]: 'Vocabulary',
    [MEASURE.SPELLING]: 'Spelling',
    [MEASURE.LNF]: 'Letter Names',
    [MEASURE.PSF]: 'Phonemic Awareness',
    [MEASURE.NWF_CLS]: 'Letter Sounds',
    [MEASURE.NWF_WRC]: 'Decoding',
    [MEASURE.WRF]: 'Word Reading',
    [MEASURE.ORF_ACC]: 'Reading Accuracy',
    [MEASURE.ORF]: 'Reading Fluency',
    [MEASURE.MAZE]: 'Basic Comprehension',
};

export const MEASURE_TITLE_SPANISH = {
    [MEASURE.TRC]: 'Comprensión lectora',
    [MEASURE.VOCABO]: 'Vocabulario',
    [MEASURE.SPELLING]: 'Ortografía',
    [MEASURE.OL]: 'Lenguaje oral',
    [MEASURE.FNL]: 'Fluidez en nombrar letras',
    [MEASURE.FSL]: 'Sonidos de letras',
    [MEASURE.FSS]: 'Conciencia fonológica',
    [MEASURE.LSS]: 'Decodificación',
    [MEASURE.FEP]: 'Lectura de palabras',
    [MEASURE.FLO]: 'Fluidez en la lectura',
    [MEASURE.FLO_PREC]: 'Precisión en la lectura',
    [MEASURE.CLPL]: 'Comprensión basica',
};

export const MEASURE_DISPLAY_NAME = {
    ...MEASURE,
    [MEASURE.VOCABO]: 'VOCAB',
    [MEASURE.NWF_CLS]: 'NWF-CLS',
    [MEASURE.NWF_WRC]: 'NWF-WRC',
    [MEASURE.ORF_ACC]: 'ORF-Accu',
    [MEASURE.FLO_PREC]: 'FLO-Prec',
    [MEASURE.CLPL]: 'CP',
};

export const VOCABO_MEASURE = {
    TQVM: 'TQVM',
    FITB: 'FITB',
    BD: 'BD',
};

export const FORM_MEASURE = {
    SPELLING: 'Spelling',
};

export const VOCABO_MEASURES = [
    {
        key: VOCABO_MEASURE.TQVM,
        title: 'Two Question Vocabulary Measure',
    },
    {
        key: VOCABO_MEASURE.FITB,
        title: 'Fill in the Blank',
    },
    {
        key: VOCABO_MEASURE.BD,
        title: 'Basic Definition',
    },
];

export const D8_MEASURES = [
    MEASURE.OVERALL,
    MEASURE.LNF,
    MEASURE.PSF,
    MEASURE.NWF_CLS,
    MEASURE.NWF_WRC,
    MEASURE.WRF,
    MEASURE.ORF_ACC,
    MEASURE.ORF,
    MEASURE.MAZE,
    MEASURE.LC,
    MEASURE.IW,
    MEASURE.RW,
    MEASURE.AP,
];

export const LECTURA_MEASURES = [
    MEASURE.OVERALL,
    MEASURE.FNL,
    MEASURE.QQ,
    MEASURE.FSS,
    MEASURE.FSLI,
    MEASURE.FSL,
    MEASURE.LSS,
    MEASURE.FEP,
    MEASURE.FLO_PREC,
    MEASURE.FLO,
    MEASURE.CLPL,
];

export const MEASURES_WITH_PERCENTAGE = [MEASURE.ORF_ACC, MEASURE.FLO_PREC];

export const getVocaboMeasureTitleByKey = key =>
    get(
        VOCABO_MEASURES.find(measure => measure.key === key),
        'title',
        '',
    );

export const TRC_OL_MEASURES = [MEASURE.TRC, MEASURE.OL];

export const SKILLS = {
    OVERALL: 'OVERALL',
    TRC: 'Reading Comprehension',
    VOCABO: 'Vocabulary',

    BASIC_COMPREHENSION: 'Basic Comprehension',
    DECODING: 'Decoding',
    PHONOLOGICAL_AWARENESS: 'Phonological Awareness',
    LETTER_NAMES: 'Letter Names',
    LETTER_SOUNDS: 'Letter Sounds',
    READING_ACCURACY: 'Reading Accuracy',
    READING_FLUENCY: 'Reading Fluency',
    WORD_READING: 'Word Reading',
};
